const Routes = Object.freeze({
  ROOT: "/pharmacy/",
  NEW_PATIENT: "new-patient",
  SEARCH_RESULTS: "search-results",
  RECENT_PATIENTS: "recent-patients",
  LOGIN: "login",
  LOGOUT: "logout",
  CALLBACK: "/callback",
  SAVEDLISTS: "savedLists"
});

export { Routes };
